import { useContext } from "react";
import AppContext from '../store/AppContext';

const useAuth=()=>{
    return useContext(AppContext);
}

export default useAuth;